exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-data-label-hover:hover {\n  background-color: #f5f5f5;\n}\n.drag-icon-img {\n  width: 15px;\n}\n.drag-stop {\n          user-drag: none;\n  -webkit-user-drag: none;\n          user-select: none;\n     -moz-user-select: none;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n}\n", ""]);

// exports
